module.exports = __webpack_public_path__ + "static/media/WarehouseView Intro.bd133f12.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/WarehouseView Intro.svg
// module id = 1498
// module chunks = 0